(function ($, document, window) {
	'use strict';

	$(function () {
		$('.js-image-gallery').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const totalSlides = sliderContainer.data('total-images');
			const fractionEl = $('.js-gallery-fraction', sliderContainer)[0];
			$(fractionEl).html(`1/${totalSlides}`);

			let breakpoints = {
				570: {
					slidesPerView: 1.4,
					spaceBetween: 28,
				},
				1024: {
					slidesPerView: 1.7,
					spaceBetween: 32,
				},
				1400: {
					slidesPerView: 1.7,
					spaceBetween: 32,
				}
			};


			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				loop: true,
				slidesPerView: 1.25,
				centeredSlides: true,
				spaceBetween: 28,
				pagination: {
					clickable: true,
					el: $('.js-dot-nav', sliderContainer)[0],
					type: 'bullets',
				},
				breakpoints,
				navigation: {
					nextEl: $('.js-carousel-nav-next', sliderContainer)[0],
					prevEl: $('.js-carousel-nav-prev', sliderContainer)[0],
				},
				on: {
					beforeInit: function () {
						let numSlides = this.wrapperEl.querySelectorAll('.js-carousel-slide').length;

						if (numSlides <= 4) {
							this.params.loop = false;
							this.params.initialSlide = 1;
						}
					},

					slideChange: function(swiper) {
						$(fractionEl).html(`${swiper.realIndex + 1}/${totalSlides}`);
					}
				}
			});
		});
	});
})(jQuery, document, window);
